<template>
    <div class="add-user">
        <div class="slider-left">
            <nav-slider :active='thisActive'></nav-slider>
        </div>
        <div class="content">
            <div class="title-wrap">
                <h3 class="title">
                    新增账户  
                </h3>
            </div>
            <el-form ref="form" :model="addForm" label-width="100px">
                <el-form-item label="姓名 : ">
                    <el-input v-model="addForm.name" @blur="addForm.name.length>0?ifName=true:ifName=false">
                        <i slot="suffix"  v-if="ifName" class="el-input__icon el-icon-circle-check" style="color:rgba(67, 207, 124, 1)"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="角色 : ">
                    <el-select v-model="addForm.role" placeholder="请选择">
                            <el-option
                            v-for="item in roles"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账号/手机号 : ">
                    <el-input v-model="addForm.phone" type='number' @blur="addForm.phone.length>0?ifPhone=true:ifPhone=false">
                        <i slot="suffix"  v-if="ifPhone" class="el-input__icon el-icon-circle-check" style="color:rgba(67, 207, 124, 1)"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="密码 : " >
                    <el-input v-model="addForm.password" type='password' @blur="addForm.password.length>0?ifPassword=true:ifPassword=false">
                        <i slot="suffix"  v-if="ifPassword" class="el-input__icon el-icon-circle-check" style="color:rgba(67, 207, 124, 1)"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="微信绑定 : ">
                    <p>为确保账户安全，请使用微信扫描下方二维码，绑定账号</p>
                </el-form-item>
                <el-form-item>
                        <img src="../assets/er.png" alt="">
                        <h3>微信扫一扫 绑定信息</h3>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                </el-form-item>
            </el-form>
            <div class="tips">
                <p style="color:rgba(166, 166, 166, 1);font-size:18px">说明</p>
                <p>为提升账号安全，需要使用 <span>技术员或管理人员</span> 微信扫码绑定！</p>
                <p>绑定后，可快捷扫码登陆，而且可在手机端进行管理操作。</p>
            </div>

        </div>
        

    </div>
</template>

<script>
    import navSlider from '../components/slider'
    export default {
        components:{navSlider},
        data() {
            return {
                ifName:false,
                ifPhone:false,
                ifPassword:false,
                roles:[{
                        value:"负责人"
                    },{
                        value:'管理员'
                    },{
                        value:'操作员'
                    },{
                        value:'财务'
                }],
                addForm: {
                    name:'',    
                    role:'',
                    phone:'',
                    password:'',
                }
            }
        },
        methods: {
            onSubmit() {
                if(!this.ifName){
                    this.$message.error('请输入姓名');
                    return
                }
                if(!this.addForm.role){
                    this.$message.error('请选择角色');
                    return
                }
                if(!this.ifPhone){
                    this.$message.error('请输入账号/手机');
                    return
                }
                if(!this.ifPassword){
                    this.$message.error('请输入密码');
                    return
                }
                
            }
        },
        mounted() {
            if(this.$route.query.id){
                //在此提交查询请求
                this.addForm={
                    name:'房东惠',
                    role:'管理员',
                    phone:'18151532235',
                    password:'123456',
                }
            }
        },
        
    }
</script>

<style scoped lang='stylus'>
.add-user{
    .slider-left{
        width:15%
        float left
    }
    .content{
        float right
        width 82%
        padding: 5px
    }
    .title-wrap{
            padding-bottom 10px
            border-bottom 1px solid rgba(232, 232, 232, 1)    
            margin-bottom 20px 
        }
    .title{
            border-left 5px solid rgba(93, 91, 91, 1)
            padding-left 10px
            .el-button{
                margin-left 20px
        }
    } 
    .el-input{
        width 435px
    }
    .el-form-item p{
        padding-left 20px
        background rgba(230, 247, 255, 1)
        width 490px
        height 40px
        line-height 40px
        border 1px solid  rgba(145, 213, 255, 1)
    }
    .el-form-item{
        img{
            width 176px
            height 176px
        }
        h3{
            color rgba(128, 128, 128, 1)
            font-size 11px
            width 150px
            text-align center
            position relative
            top: -20px;
            left: 10px;
        }
    }
    .tips{
        padding 10px 0 10px 50px
        border-top 1px solid  #eee 
        p{
            margin-top 15px
            span{
                color rgba(212, 48, 48, 1)
                font-size 16px
                font-weight bold 
            }
        }
    }
}

</style>
<style lang='stylus'>
    .add-user{
        input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        input[type="number"] {
            -moz-appearance: textfield;
        }
    }
</style>
